import styled from 'styled-components/macro';
import { BREAKPOINTS, deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const RadioContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  width: 100%;
  height: 100%;
`;

export const AnswerBlock = styled.label`
  ${FLEX_CONTAINER.FlexStartRow};
  width: 100%;
  cursor: pointer;
  ${FONTS.font16}
  @media ${BREAKPOINTS.md} {
    ${FONTS.font14}
    padding-right:10px;
    word-break: break-all;
  }
`;

export const Container = styled.div`
  padding-left: 28px;
  width: 100%;

  @media ${deviceMax.tablet} {
    padding-left: 0;
  }
`;

export const CurrentQuestionText = styled.h2`
  ${FONTS.font20}
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontMedium}
`;

export const RadioBox = styled.div`
  margin-top: 30px;
  margin-right: 76px;
  height: 300px;
  width: 100%;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
  @media ${BREAKPOINTS.lg} {
    height: 300px;
  }
`;

export const StyledCheckBox = styled.input`
  width: 24px;
  height: 24px;
  accent-color: ${COLORS.mainColor};
  -webkit-appearance: none;
  border: 1px solid ${COLORS.mainColor};
  border-radius: 50px;
  margin-right: 10px;
  padding: 6px;
  cursor: pointer;

  &:checked {
    -webkit-appearance: checkbox;
  }
  @media ${BREAKPOINTS.md} {
    width: 16px;
    height: 16px;
  }
`;

export const LabelText = styled.label`
  ${FONTS.font16}
  margin-top: 3px;
  margin-left: 7px;
`;

export const CheckboxItem = styled.div`
  margin-top: 6px;
`;

export const CheckboxText = styled.p`
  margin-right: 16px;
`;

export const TextArea = styled.textarea`
  width: 826px;
  height: 92px;
  background: ${COLORS.lightGray};
  border-radius: 12px;
  outline: none;
  margin-top: 18px;
  padding: 8px 10px;
  resize: none;
  @media ${deviceMax.laptopM} {
    width: 640px;
  }
  @media ${deviceMax.laptop} {
    width: 480px;
  }
  @media ${deviceMax.tablet} {
    width: 300px;
    margin: 12px;
  }
  @media ${deviceMax.mobileL} {
    width: 230px;
    margin: 7px;
  }
`;
